"use client";

import React from "react";
import { Anchor, Clock, Globe, MapPin, Shield, Zap } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const locations = [{
  id: "ai-vetting",
  name: "PocketPal AI",
  region: "Analysis",
  top: "35%",
  left: "25%",
  status: "Processing",
  details: "Scanning millions of square feet to find your perfect industrial or office match."
}, {
  id: "data-match",
  name: "Market Match",
  region: "Precision",
  top: "22%",
  left: "47%",
  status: "Verified",
  details: "AI-driven vetting ensures every listing meets your specific operational requirements."
}, {
  id: "broker-sync",
  name: "Elite Broker",
  region: "Human Expert",
  top: "45%",
  left: "55%",
  status: "On Call",
  details: "Top-tier Phoenix brokers take the handoff to negotiate your final terms."
}, {
  id: "success",
  name: "The Closing",
  region: "Result",
  top: "32%",
  left: "75%",
  status: "Complete",
  details: "Seamless transition from digital search to physical space. You just sign."
}];
const metrics = [{
  title: "AI Vetting",
  value: "100%",
  desc: "Automated Screening",
  icon: Zap
}, {
  title: "Handoff",
  value: "INSTANT",
  desc: "Human Sync",
  icon: Clock
}, {
  title: "Experience",
  value: "ELITE",
  desc: "Local Experts",
  icon: Anchor
}, {
  title: "Tenant Cost",
  value: "$0",
  desc: "Always Free",
  icon: Shield
}];
export default function GlobalOperationalManagement() {
  return;
}